// /src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AppContent from "./AppContent";
import { SupabaseAuthProvider } from "./contexts/SupabaseAuthContext";
import { ProfileProvider } from "./contexts/ProfileContext";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminUI from "./components/AdminUI";
import IntroApp from "./IntroApp";
import ReviewDialogs from "./components/ReviewDialogs";
import GenerateMissingDialogs from "./components/GenerateMissingDialogs";
import ZamboniScanAll from "./components/ZamboniScanAll";

// Add global unhandled promise rejection handler
window.addEventListener("unhandledrejection", (event) => {
  // Prevent the default browser behavior of logging the error
  event.preventDefault();

  // Check if it's the message channel closed error and ignore it
  if (
    event.reason &&
    event.reason.message &&
    event.reason.message.includes("message channel closed")
  ) {
    console.log(
      "Suppressed unhandled promise rejection for message channel closed"
    );
    return;
  }

  // Log other unhandled promise rejections
  console.error("Unhandled promise rejection:", event.reason);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SupabaseAuthProvider>
      <ProfileProvider>
        <BrowserRouter
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <Routes>
            <Route path="/admin" element={<AdminUI />} />
            <Route path="/intro" element={<IntroApp />} />
            <Route path="/review-dialogs" element={<ReviewDialogs />} />
            <Route
              path="/generate-missing-dialogs"
              element={<GenerateMissingDialogs />}
            />
            <Route path="/zamboni-scan" element={<ZamboniScanAll />} />
            <Route path="*" element={<AppContent />} />
          </Routes>
        </BrowserRouter>
      </ProfileProvider>
    </SupabaseAuthProvider>
  </React.StrictMode>
);
